/**
 * Focus the first control React has marked invalid after the current submit
 * update is committed. Keeping this in one helper makes error recovery
 * consistent without moving focus to non-interactive error copy.
 */
export function focusFirstInvalid(form: HTMLFormElement): void {
  if (typeof window === 'undefined') return
  window.requestAnimationFrame(() => {
    if (!form.isConnected) return
    form.querySelector<HTMLElement>('[aria-invalid="true"]')?.focus({ preventScroll: false })
  })
}

